export const COMMAND_V2_DIALOG_CONTENT_CLASS =
    "flex max-h-[90vh] w-[calc(100%-2rem)] flex-col gap-0 overflow-hidden rounded-[32px] border-border bg-background p-5 shadow-xl sm:rounded-[32px] sm:p-6 [&>button:last-child]:hidden";
